/**
 * Where the cloud portal is: what a node-served page links to for a cloud-only screen it cannot reach the cloud for
 * (`views/CloudOnlyPage.tsx`) and for the node's "no studios yet" state. Pure: the services compute it once from the
 * runtime config.
 */
import { cloudPortalOrigin, type RuntimeConfigWire } from '@acp/api-contract/runtimeConfig.js';

/**
 * The cloud portal's origin: the page's own on a cloud-served page, else the stage's (from the config's cloud status
 * endpoint, `cloudPortalOrigin`), or null when the node runs without a cloud or the name has another shape.
 */
export function cloudPortalUrl(config: RuntimeConfigWire, origin: string): string | null {
  if (config.backend.kind === 'cloud') return origin;
  const cloud = config.status?.cloud ?? null;
  return cloud === null ? null : cloudPortalOrigin(cloud.apiUrl);
}

/** A path in the cloud portal, or null when there is none to link to. */
export function portalLink(portal: string | null, path: string): string | null {
  return portal === null ? null : `${portal}${path}`;
}
